import React from 'react';

import { Button } from "react-bootstrap";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import UbicacionCompoent from "../components/UbicacionComponent";
import Fancybox from "../components/Fancybox";
import { Link } from "react-router-dom";


import PlantasComponent from "../components/PlantasComponent";

const Plantas = () => {

    const slideModelos = {
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className="page plantas">

            {/* Verson de telefonos */}
            <section id="hero">
                <div className="imagen"></div>
                <div className="contenido">
                    <img
                        src="/images/plantas/logo_celular.png"
                        alt="Logo Edificio Almirante"
                    />
                    <p className="texto">DESCUBRE TU <span>NUEVA INVERSIÓN</span></p>
                </div>
            </section>

            <section id="plantas">
                <div className="iconos">
                    <div className="icono">
                        <img
                            src="/images/plantas/icono_7_celular.svg"
                            alt="Cocina Equipada"
                        />
                        <p className="texto">Cocina <span>Equipada</span></p>
                    </div>
                    <div className="icono">
                        <img
                            src="/images/plantas/icono_8_celular.svg"
                            alt="Conexión Lavadora"
                        />
                        <p className="texto">Conexión <span>Lavadora</span></p>
                    </div>
                    <div className="icono">
                        <img
                            src="/images/plantas/icono_9_celular.svg"
                            alt="Ventanas Termopanel"
                        />
                        <p className="texto">Ventanas <span>Termopanel</span></p>
                    </div>
                    <div className="icono">
                        <img
                            src="/images/plantas/icono_10_celular.svg"
                            alt="Ventanas Termopanel"
                        />
                        <p className="texto">Baño <span>Suite</span></p>
                    </div>
                </div>

                <div className="titulo-arriba">
                    <p>Tamaños y distribución</p>
                </div>

                <div className="titulo">
                    <p className="big">PLANTAS</p>
                    <p className="small">ESPACIOS PENSADOS PARA <span>TU COMODIDAD</span></p>
                </div>

                <div className="slide-plantas">
                    <Slider {...slideModelos}>
                        <div className="item">
                            <div className="contenido">
                                <div className="in">
                                    <div className="imagen">
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            <a href="/images/plantas/planta_b_escritorio.png" data-fancybox="gallery" data-caption="Planta B">
                                                <img
                                                    src="/images/plantas/planta_b_celular.png"
                                                    alt="planta b"
                                                />
                                            </a>
                                        </Fancybox>
                                    </div>
                                    <div className="contenido-in">
                                        <div className="especificaciones">
                                            <p className="modelo-nombre">Modelo B</p>
                                            <p className="especificacion-1">Tipo estudio</p>
                                            <p className="especificacion-2">1 baño</p>

                                            <p className="metros">22,9 m<sup>2</sup></p>
                                            <p className="total">totales</p>
                                        </div>
                                        <div className="incluye">
                                            <div className="franja">Incluye</div>
                                            <div className="incliuye-item">Cocina equipada</div>
                                            <div className="incliuye-item">Encimera</div>
                                            <div className="incliuye-item">Horno</div>
                                            <div className="incliuye-item">Campana</div>
                                        </div>
                                    </div>

                                    <div className="boton-cotiza">
                                        <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                                            Cotiza
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="contenido">
                                <div className="in">
                                    <div className="imagen">
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            <a href="/images/plantas/planta_c_escritorio.png" data-fancybox="gallery" data-caption="Planta C">
                                                <img
                                                    src="/images/plantas/planta_c_celular.png"
                                                    alt="modelo c"
                                                />
                                            </a>
                                        </Fancybox>
                                    </div>
                                    <div className="contenido-in">
                                        <div className="especificaciones">
                                            <p className="modelo-nombre">Modelo C</p>
                                            <p className="especificacion-1">1 dormitorio</p>
                                            <p className="especificacion-2">1 baño</p>

                                            <p className="metros">34,9 m<sup>2</sup></p>
                                            <p className="total">totales</p>
                                        </div>
                                        <div className="incluye">
                                            <div className="franja">Incluye</div>
                                            <div className="incliuye-item">Cocina equipada</div>
                                            <div className="incliuye-item">Encimera</div>
                                            <div className="incliuye-item">Horno</div>
                                            <div className="incliuye-item">Campana</div>
                                            <div className="incliuye-item">Conexión a lavadora</div>
                                        </div>
                                    </div>

                                    <div className="boton-cotiza">
                                        <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                                            Cotiza
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="contenido">
                                <div className="in">
                                    <div className="imagen">
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            <a href="/images/plantas/planta_e_escritorio.png" data-fancybox="gallery" data-caption="Planta E">
                                                <img
                                                    src="/images/plantas/planta_e_celular.png"
                                                    alt="modelo e"
                                                />
                                            </a>
                                        </Fancybox>
                                    </div>
                                    <div className="contenido-in">
                                        <div className="especificaciones">
                                            <p className="modelo-nombre">Modelo E</p>
                                            <p className="especificacion-1">2 dormitorio</p>
                                            <p className="especificacion-2">1 baño</p>

                                            <p className="metros">38,8 m<sup>2</sup></p>
                                            <p className="total">totales</p>
                                        </div>
                                        <div className="incluye">
                                            <div className="franja">Incluye</div>
                                            <div className="incliuye-item">Cocina equipada</div>
                                            <div className="incliuye-item">Encimera</div>
                                            <div className="incliuye-item">Horno</div>
                                            <div className="incliuye-item">Campana</div>
                                            <div className="incliuye-item">Conexión a lavadora</div>
                                        </div>
                                    </div>

                                    <div className="boton-cotiza">
                                        <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                                            Cotiza
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="contenido">
                                <div className="in">
                                    <div className="imagen">
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            <a href="/images/plantas/planta_d_escritorio.png" data-fancybox="gallery" data-caption="Planta D">
                                                <img
                                                    src="/images/plantas/planta_d_celular.png"
                                                    alt="modelo d"
                                                />
                                            </a>
                                        </Fancybox>
                                    </div>
                                    <div className="contenido-in">
                                        <div className="especificaciones">
                                            <p className="modelo-nombre">Modelo D</p>
                                            <p className="especificacion-1">2 dormitorio</p>
                                            <p className="especificacion-2">2 baños</p>

                                            <p className="metros">41,5 m<sup>2</sup></p>
                                            <p className="total">totales</p>
                                        </div>
                                        <div className="incluye">
                                            <div className="franja">Incluye</div>
                                            <div className="incliuye-item">Cocina equipada</div>
                                            <div className="incliuye-item">Encimera</div>
                                            <div className="incliuye-item">Horno</div>
                                            <div className="incliuye-item">Campana</div>
                                            <div className="incliuye-item">Conexión a lavadora</div>
                                        </div>
                                    </div>

                                    <div className="boton-cotiza">
                                        <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                                            Cotiza
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item verde">
                            <div className="contenido">
                                <div className="franja-texto"> Modelo único / Solo una unidad </div>
                                <div className="in">
                                    <div className="imagen">
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            <a href="/images/plantas/planta_f_escritorio.png" data-fancybox="gallery" data-caption="Planta F">
                                                <img
                                                    src="/images/plantas/planta_f_celular.png"
                                                    alt="modelo F"
                                                />
                                            </a>
                                        </Fancybox>
                                    </div>
                                    <div className="contenido-in">
                                        <div className="especificaciones">
                                            <p className="modelo-nombre">Modelo F</p>
                                            <p className="especificacion-1">2 dormitorio</p>
                                            <p className="especificacion-2">2 baños</p>

                                            <p className="metros">45,4 m<sup>2</sup></p>
                                            <p className="total">totales</p>
                                        </div>
                                        <div className="incluye">
                                            <div className="franja">Incluye</div>
                                            <div className="incliuye-item">Cocina equipada</div>
                                            <div className="incliuye-item">Encimera</div>
                                            <div className="incliuye-item">Horno</div>
                                            <div className="incliuye-item">Campana</div>
                                            <div className="incliuye-item">Conexión a lavadora</div>
                                        </div>
                                    </div>

                                    <div className="boton-cotiza">
                                        <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                                            Cotiza
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="contenido">
                                <div className="in">
                                    <div className="imagen">
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            <a href="/images/plantas/planta_a_escritorio.png" data-fancybox="gallery" data-caption="Planta A">
                                                <img
                                                    src="/images/plantas/planta_a_celular.png"
                                                    alt="modelo a"
                                                />
                                            </a>
                                        </Fancybox>
                                    </div>
                                    <div className="contenido-in">
                                        <div className="especificaciones">
                                            <p className="modelo-nombre">Modelo A</p>
                                            <p className="especificacion-1">2 dormitorio</p>
                                            <p className="especificacion-2">2 baños</p>
                                            <p className="especificacion-2">Con Terraza</p>

                                            <p className="metros">46,07 m<sup>2</sup> <small>interior</small></p>
                                            <p className="total">51,2 m<sup>2</sup> <small>totales</small></p>
                                        </div>
                                        <div className="incluye">
                                            <div className="franja">Incluye</div>
                                            <div className="incliuye-item">Cocina equipada</div>
                                            <div className="incliuye-item">Encimera</div>
                                            <div className="incliuye-item">Horno</div>
                                            <div className="incliuye-item">Campana</div>
                                            <div className="incliuye-item">Conexión a lavadora</div>
                                            <div className="incliuye-item">Terraza con baranda de vidrio</div>
                                        </div>
                                    </div>
                                    <div className="boton-cotiza">
                                        <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                                            Cotiza
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="contenido">
                                <div className="in">
                                    <div className="imagen">
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            <a href="/images/plantas/planta_a0_escritorio.png" data-fancybox="gallery" data-caption="Planta A0">
                                                <img
                                                    src="/images/plantas/planta_a0_celular.png"
                                                    alt="modelo a"
                                                />
                                            </a>
                                        </Fancybox>
                                    </div>
                                    <div className="contenido-in">
                                        <div className="especificaciones">
                                            <p className="modelo-nombre">Modelo A0</p>
                                            <p className="especificacion-1">2 dormitorio</p>
                                            <p className="especificacion-2">2 baños</p>
                                            <p className="especificacion-2">Con Terraza</p>

                                            <p className="metros">47,08 m<sup>2</sup></p>
                                            <p className="total">totales</p>
                                        </div>
                                        <div className="incluye">
                                            <div className="franja">Incluye</div>
                                            <div className="incliuye-item">Cocina equipada</div>
                                            <div className="incliuye-item">Encimera</div>
                                            <div className="incliuye-item">Horno</div>
                                            <div className="incliuye-item">Campana</div>
                                            <div className="incliuye-item">Conexión a lavadora</div>
                                        </div>
                                    </div>

                                    <div className="boton-cotiza">
                                        <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                                            Cotiza
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="contenido">
                                <div className="in">
                                    <div className="imagen">
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            <a href="/images/plantas/planta_a._escritorio.png" data-fancybox="gallery" data-caption="Planta A.">

                                                <img
                                                    src="/images/plantas/planta_a._celular.png"
                                                    alt="modelo a."
                                                />
                                            </a>
                                        </Fancybox>
                                    </div>
                                    <div className="contenido-in">
                                        <div className="especificaciones">
                                            <p className="modelo-nombre">Modelo A.</p>
                                            <p className="especificacion-1">2 dormitorio</p>
                                            <p className="especificacion-2">2 baños</p>
                                            <p className="especificacion-2">Con Terraza</p>

                                            <p className="metros">47,05 m<sup>2</sup> <small>interior</small></p>
                                            <p className="total">54,9 m<sup>2</sup> <small>totales</small></p>
                                        </div>
                                        <div className="incluye">
                                            <div className="franja">Incluye</div>
                                            <div className="incliuye-item">Cocina equipada</div>
                                            <div className="incliuye-item">Encimera</div>
                                            <div className="incliuye-item">Horno</div>
                                            <div className="incliuye-item">Campana</div>
                                            <div className="incliuye-item">Conexión a lavadora</div>
                                        </div>
                                    </div>

                                    <div className="boton-cotiza">
                                        <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                                            Cotiza
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="contenido">
                                <div className="in">
                                    <div className="imagen">
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            <a href="/images/plantas/planta_a1_escritorio.png" data-fancybox="gallery" data-caption="Planta A1">
                                                <img
                                                    src="/images/plantas/planta_a1_celular.png"
                                                    alt="modelo a1"
                                                />
                                            </a>
                                        </Fancybox>
                                    </div>
                                    <div className="contenido-in">
                                        <div className="especificaciones">
                                            <p className="modelo-nombre">Modelo A1</p>
                                            <p className="especificacion-1">2 dormitorio</p>
                                            <p className="especificacion-2">2 baños</p>
                                            <p className="especificacion-2">Con Balcon</p>

                                            <p className="metros">50,69 m<sup>2</sup> <small>interior</small></p>
                                            <p className="total">52,6 m<sup>2</sup> <small>totales</small></p>
                                        </div>
                                        <div className="incluye">
                                            <div className="franja">Incluye</div>
                                            <div className="incliuye-item">Cocina equipada</div>
                                            <div className="incliuye-item">Encimera</div>
                                            <div className="incliuye-item">Horno</div>
                                            <div className="incliuye-item">Campana</div>
                                            <div className="incliuye-item">Conexión a lavadora</div>
                                            <div className="incliuye-item">Terraza con baranda de vidrio</div>
                                            <div className="incliuye-item">Baño con ventilación natural</div>
                                        </div>
                                    </div>

                                    <div className="boton-cotiza">
                                        <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                                            Cotiza
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="contenido">
                                <div className="in">
                                    <div className="imagen">
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            <a href="/images/plantas/planta_a2_escritorio.png" data-fancybox="gallery" data-caption="Planta A2">
                                                <img
                                                    src="/images/plantas/planta_a2_celular.png"
                                                    alt="modelo a1"
                                                />
                                            </a>
                                        </Fancybox>
                                    </div>
                                    <div className="contenido-in">
                                        <div className="especificaciones">
                                            <p className="modelo-nombre">Modelo A2</p>
                                            <p className="especificacion-1">2 dormitorio</p>
                                            <p className="especificacion-2">2 baños</p>

                                            <p className="metros">51,5 m<sup>2</sup> </p>
                                            <p className="total">totales</p>
                                        </div>
                                        <div className="incluye">
                                            <div className="franja">Incluye</div>
                                            <div className="incliuye-item">Cocina equipada</div>
                                            <div className="incliuye-item">Encimera</div>
                                            <div className="incliuye-item">Horno</div>
                                            <div className="incliuye-item">Campana</div>
                                            <div className="incliuye-item">Conexión a lavadora</div>
                                        </div>
                                    </div>

                                    <div className="boton-cotiza">
                                        <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                                            Cotiza
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </section>

            {/* Version tablet y note */}
            <section id="hero-desk">
                <div className="contenido">
                    <p className="titulo">DESCUBRE TU <span>NUEVA INVERSIÓN</span></p>
                    <p className="titulo-dos">CON LA <span>VANGUARDIA DE</span> LA ARQUITECTURA MODERNA</p>
                    <p className="texto">Maximiza tu inversión con <span>altos rendimientos en Airbnb</span></p>
                </div>
                <div className="fondo"></div>
            </section>

            <section id="plantas-desk">
                <p className="titulo-small">Tamaños y distribución</p>
                <div className="conjunto-titulo">
                    <p className="big">PLANTAS</p>
                    <p className="small">ESPACIOS PENSADOS <span>PARA TU COMODIDAD</span></p>
                </div>

                <div className="iconos">
                    <div className="icono">
                        <div className="tablet">
                            <img
                                src={"/images/plantas/icono_10_tablet.svg"}
                                alt="icono cocina"
                            />
                        </div>
                        <div className="note">
                            <img
                                src={"/images/plantas/icono_6_escritorio.svg"}
                                alt="icono cocina"
                            />
                        </div>
                        <p className="texto">Cocina <span>Equipada</span></p>
                        <p className="texto-small">Cocina FDV Línea Black</p>
                    </div>
                    <div className="icono">
                        <div className="tablet">
                            <img
                                src={"/images/plantas/icono_11_tablet.svg"}
                                alt="icono cocina"
                            />
                        </div>
                        <div className="note">
                            <img
                                src={"/images/plantas/icono_7_escritorio.svg"}
                                alt="icono cocina"
                            />
                        </div>
                        <p className="texto">Conexión <span>Lavadora</span></p>
                        <p className="texto-small">Espacio útil y necesario</p>

                    </div>
                    <div className="icono">
                        <div className="tablet">
                            <img
                                src={"/images/plantas/icono_12_tablet.svg"}
                                alt="icono cocina"
                            />
                        </div>
                        <div className="note">
                            <img
                                src={"/images/plantas/icono_8_escritorio.svg"}
                                alt="icono cocina"
                            />
                        </div>
                        <p className="texto">Ventanas <span>Termopanel</span></p>
                        <p className="texto-small">Aislante de ruidos y <span> temperaturas altas y bajas</span></p>

                    </div>
                    <div className="icono">
                        <div className="tablet">
                            <img
                                src={"/images/plantas/icono_13_tablet.svg"}
                                alt="icono cocina"
                            />
                        </div>
                        <div className="note">
                            <img
                                src={"/images/plantas/icono_9_escritorio.svg"}
                                alt="icono cocina"
                            />
                        </div>
                        <p className="texto">Baño Suite</p>
                        <p className="texto-small">Pisos de cerámica en baños
                            <span>Baños principales con pie de </span>ducha tipo hotel</p>

                    </div>
                </div>

                <div className="plantas-desk">
                    <div className="planta-destacada">
                        <PlantasComponent
                            imagen={"/images/plantas/planta_b_tablet.png"}
                            imagenDesk={"/images/plantas/planta_b_escritorio.png"}
                            width={491}
                            height={404}
                            nombre={"Modelo B"}
                            info={["Tipo estudio", "1 baño"]}
                            metros={"22,9"}
                            incluye={["Cocina equipada", "Encimera", "Horno", "Campana"]}
                            destacada={true}
                        />
                    </div>

                    <div className="franja-360">
                        <p>No te quedes con dudas, <span> vuelve a revisar nuestro recorrido 360°</span></p>
                    </div>

                    <div>
                        <div className="planta">
                            <PlantasComponent
                                imagen={"/images/plantas/planta_c_tablet.png"}
                                imagenDesk={"/images/plantas/planta_c_escritorio.png"}
                                width={347}
                                height={292}
                                nombre={"Modelo C"}
                                info={["1 dormitorio", "1 baño"]}
                                metros={"34,9"}
                                incluye={["Cocina equipada", "Encimera", "Horno", "Campana", "Conexión a lavadora"]}
                                footerFlex={true}
                                fondoColor=" #F4F4F2"
                            />
                        </div>
                        <div className="planta">
                            <PlantasComponent
                                imagen={"/images/plantas/planta_e_tablet.png"}
                                imagenDesk={"/images/plantas/plante_e_escrito.png"}
                                width={278}
                                height={302}
                                nombre={"Modelo E"}
                                info={["2 dormitorios", "1 baño"]}
                                metros={"38,8"}
                                incluye={["Cocina equipada", "Encimera", "Horno", "Campana", "Conexión a lavadora"]}
                                footerFlex={true}
                                fondoColor=" #F4F4F2"
                                reverse={true}
                            />
                        </div>
                        <div className="planta">
                            <PlantasComponent
                                imagen={"/images/plantas/planta_d_tablet.png"}
                                imagenDesk={"/images/plantas/planta_d_escritorio.png"}
                                width={338}
                                height={239}
                                nombre={"Modelo D"}
                                info={["2 dormitorios", "2 baños"]}
                                metros={"41,5"}
                                incluye={["Cocina equipada", "Encimera", "Horno", "Campana"]}
                                footerFlex={true}
                                fondoColor=" #F4F4F2"
                            />
                        </div>
                    </div>

                    <div className="banner-parallax">
                        <div className="fondo"></div>
                        <div className="franja-verde"> <p> Modelo único / Solo una unidad </p> </div>
                    </div>

                    <div>
                        <div className="planta">
                            <PlantasComponent
                                imagen={"/images/plantas/planta_f_tablet.png"}
                                imagenDesk={"/images/plantas/planta_f_escritorio.png"}
                                width={368}
                                height={241}
                                nombre={"Modelo F"}
                                info={["2 dormitorios", "2 baños"]}
                                metros={"45,4"}
                                incluye={["Cocina equipada", "Encimera", "Horno", "Campana", "Conexión a lavadora"]}
                                footerFlex={true}
                                fondoColor=" #595E39"
                                reverse={true}
                                ultimaUnidad={true}
                            />
                        </div>

                        <div className="planta destacada-medio">
                            <PlantasComponent
                                imagen={"/images/plantas/planta_a_tablet.png"}
                                imagenDesk={"/images/plantas/planta_a_escritorio.png"}
                                width={479}
                                height={339}
                                nombre={"Modelo A"}
                                info={["2 dormitorios", "2 baños", "Con terraza"]}
                                metros={"51,2"}
                                incluye={["Cocina equipada", "Encimera", "Horno", "Campana", "Conexión a lavadora", "Terraza con barandas de vidrio"]}
                                destacada={true}
                            />
                        </div>

                        <div className="planta">
                            <PlantasComponent
                                imagen={"/images/plantas/planta_a._tablet.png"}
                                imagenDesk={"/images/plantas/planta_a._escritorio.png"}
                                width={322}
                                height={259}
                                nombre={"Modelo A."}
                                info={["2 dormitorios", "2 baños", "Con terraza"]}
                                metros={"54,9"}
                                incluye={["Cocina equipada", "Encimera", "Horno", "Campana", "Conexión a lavadora"]}
                                footerFlex={true}
                                fondoColor=" #F4F4F2"
                            />
                        </div>

                        <div className="planta">
                            <PlantasComponent
                                imagen={"/images/plantas/planta_a0_tablet.png"}
                                imagenDesk={"/images/plantas/planta_a0_escritorio.png"}
                                width={322}
                                height={259}
                                nombre={"Modelo A0"}
                                info={["2 dormitorios", "2 baños"]}
                                metros={"57,08"}
                                incluye={["Cocina equipada", "Encimera", "Horno", "Campana", "Conexión a lavadora"]}
                                footerFlex={true}
                                fondoColor=" #F4F4F2"
                                reverse={true}
                            />
                        </div>

                        <div className="planta">
                            <PlantasComponent
                                imagen={"/images/plantas/planta_a1_tablet.png"}
                                imagenDesk={"/images/plantas/planta_a1_escritorio.png"}
                                width={352}
                                height={248}
                                nombre={"Modelo A1"}
                                info={["2 dormitorios", "2 baños", "Con balcón"]}
                                metros={"52,6"}
                                incluye={["Cocina equipada", "Encimera", "Horno", "Campana", "Conexión a lavadora", "Terraza con barandas de vidrio", "Baño con ventilación natural"]}
                                footerFlex={true}
                                fondoColor=" #F4F4F2"
                            />
                        </div>
                        <div className="planta">
                            <PlantasComponent
                                imagen={"/images/plantas/planta_a2_tablet.png"}
                                imagenDesk={"/images/plantas/planta_a3_escritorio.png"}
                                width={357}
                                height={267}
                                nombre={"Modelo A2"}
                                info={["2 dormitorios", "2 baños"]}
                                metros={"51,5"}
                                incluye={["Cocina equipada", "Encimera", "Horno", "Campana", "Conexión a lavadora"]}
                                footerFlex={true}
                                fondoColor=" #F4F4F2"
                                reverse={true}
                            />
                        </div>
                    </div>
                </div>
            </section>

            <UbicacionCompoent />
        </div>
    )
}

export default Plantas